import SendReceiptForm from './sendReceiptForm';

export default SendReceiptForm;
